import { render, staticRenderFns } from "./pcUserHeader.vue?vue&type=template&id=21d81f9a&scoped=true"
import script from "./pcUserHeader.vue?vue&type=script&lang=js"
export * from "./pcUserHeader.vue?vue&type=script&lang=js"
import style0 from "./pcUserHeader.vue?vue&type=style&index=0&id=21d81f9a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d81f9a",
  null
  
)

export default component.exports